export default "__VITE_ASSET__513f253a__"